import React from "react";
import { compose, graphql } from "@atlassiansox/microscopekit";
import DynamicTable from "@atlaskit/dynamic-table";
import WargameTemplateSchedulesQuery from "../../graphql/wargame-template-schedules.query.graphql";
import { ScheduleType } from "../../../__generated__/graphql-global-types";
import { WargameScheduleTableActions } from "../WargameScheduleTableActions";
var WargameTemplateScheduleView = function (props) {
    var wargameTemplateSchedules = props.schedulesData
        .schedulesByTemplateID
        ? props.schedulesData.schedulesByTemplateID.sort(function (a, b) {
            return parseInt(a.id !== undefined ? a.id : "0") -
                parseInt(b.id ? b.id : "0");
        })
        : [];
    return (React.createElement("div", null, wargameTemplateSchedules ? (React.createElement(DynamicTable, { head: {
            cells: [
                {
                    key: "id",
                    content: "ID",
                    isSortable: true
                },
                {
                    key: "schedule-type",
                    content: "Schedule Type",
                    isSortable: true
                },
                {
                    key: "cron/ Schedule Time",
                    content: "Cron/Schedule Time",
                    isSortable: true
                },
                {
                    key: "status",
                    content: "Status",
                    isSortable: true
                },
                {
                    key: "actions",
                    content: "Actions"
                }
            ]
        }, rows: wargameTemplateSchedules.map(function (wargameSchedule) { return ({
            cells: [
                {
                    content: wargameSchedule.id
                },
                {
                    content: wargameSchedule.scheduleType
                },
                {
                    content: wargameSchedule.scheduleType === ScheduleType.recurring
                        ? wargameSchedule.cronExpression
                        : wargameSchedule.scheduleType === ScheduleType.once
                            ? wargameSchedule.scheduleTime
                            : "NA"
                },
                {
                    content: wargameSchedule.status
                },
                {
                    content: (React.createElement(WargameScheduleTableActions, { wargameSchedule: wargameSchedule }))
                }
            ]
        }); }), caption: "Wargame Plan Schedule" })) : (React.createElement("p", null, "This wargame plan is not scheduled"))));
};
export var WargameTemplateScheduleList = compose(graphql(WargameTemplateSchedulesQuery, {
    name: "schedulesData",
    options: function (props) { return ({
        query: WargameTemplateSchedulesQuery,
        variables: { templateId: props.templateID },
        pollInterval: 10000
    }); }
}))(WargameTemplateScheduleView);
